import React, { useEffect, useState } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode"; // Use named import

function Dashboard() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const fetchUser = async () => {
      try {
        const decoded = jwtDecode(token);
        const res = await axios.get(
          "https://app.metabolytics.ai/simulator-backend/healthcare/dashboard",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setUser(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchUser();
  }, []);

  if (!user) return <h2>Loading...</h2>;

  return (
    <div>
      <h2>
        Welcome, {user.firstName} {user.lastName}
      </h2>
      {user.role === "Physician" && (
        <p>Dashboard for Physicians: View patient records.</p>
      )}
      {user.role === "Registered Nurse" && (
        <p>Dashboard for Nurses: Manage patient nutrition.</p>
      )}
      {user.role === "Medical Assistant" && (
        <p>Dashboard for Assistants: Assist with medical procedures.</p>
      )}
      {user.role === "Admin" && <p>Admin Dashboard: Manage Users</p>}
      <button
        onClick={() => {
          localStorage.removeItem("token"); // Only remove token
          window.location.href = "/login"; // Redirect user to login page
        }}
      >
        Logout
      </button>
    </div>
  );
}

export default Dashboard;
